import React, { useState } from 'react';
import classNames from 'classnames';
import styles from './assets/seance-actions.module.scss';

import AmountLogs from './AmountLogs';
interface Props {
    original: any;
    data: any;
    setData: any;
    paymentId: undefined | number | string;
    name: string;
    amountValue: number;
}

const SeanceActionsColumn: React.FunctionComponent<Props> = ({ original, data, name, paymentId }) => {
    const idValue = data[`${original?.id}`];

    const [valueState, setValue] = useState<string>(idValue?.[`${name}`]);

    const logs: any = [];
    let total = 0;
    if (original.paymentInvoices) {
        original.paymentInvoices.forEach((itP: any) => {
            if (paymentId && +itP.status === 1) {
                if (+itP.payment?.id !== +paymentId || (+itP.payment?.id === +paymentId && itP.paymentCredit)) {
                    logs.push(itP);
                    total += itP?.amount ? +itP?.amount : 0;
                }
            }
        });
    }
    total += valueState ? +valueState : 0;

    const actionValue = data[`${original?.id}`]?.action;

    const title: any = original?.[`${name}`];

    return (
        <div className={classNames(styles.actions)}>
            {actionValue ? (
                <div>
                    <AmountLogs logs={logs} />

                    <div style={{ display: 'flex' }}>
                        <div>
                            <input
                                className={'mb-2'}
                                value={`${valueState}`}
                                onChange={(event: any) => {
                                    event.preventDefault();

                                    setValue(`${event.target.value}`);
                                }}
                                disabled
                                type="number"
                            />

                            <div style={{ display: 'block' }}>totalValueState: {total}</div>
                        </div>

                        <div></div>
                    </div>
                </div>
            ) : (
                <div>
                    <AmountLogs logs={logs} />
                    <div>{title}</div>
                </div>
            )}
        </div>
    );
};

export default SeanceActionsColumn;
